import React from 'react';
import { IconButton } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import styles from './motorMilestones.module.css';
import CustomButton from '../../../../components/buttons/CustomButton';
import CalendarConfig from '../../../../consts/CalendarConfig';
import { ageLabel } from '../../modules/motorMilestones/motorMilestones';

/**
 * Lista dos marcos na ordem do catálogo: critério, situação, data e idade
 * da conquista. `enabled`: mostra registrar/editar/excluir.
 * `classes`: troca a classe da tabela (o PDF usa a do papel, sem critério).
 */
const MotorMilestonesTable = ({ rows, enabled = false, onRegister, onDelete, classes }) => {
  const css = classes || styles;

  return (
    <div className={classes ? undefined : styles.tableScroll}>
      <table className={css.table}>
        <thead>
          <tr>
            <th>Marco</th>
            <th>Situação</th>
            <th>Conquistado em</th>
            <th>Idade</th>
            {enabled && <th aria-label="Ações" />}
          </tr>
        </thead>
        <tbody>
          {rows.map(({ milestone, record, age, status }) => (
            <tr key={milestone.key}>
              <td>
                <span className={styles.milestoneName}>{milestone.label}</span>
                {!classes && <span className={styles.milestoneHint}>{milestone.hint}</span>}
                {record && record.note && <span className={styles.milestoneNote}>{record.note}</span>}
              </td>
              <td><span className={`${styles.status} ${styles[status.tone]}`}>{status.label}</span></td>
              <td className={styles.nowrap}>{record ? CalendarConfig.GetDDMMAAAA(record.achievedAt) : '—'}</td>
              <td className={styles.nowrap}>{record ? ageLabel(age) : '—'}</td>
              {enabled && (
                <td className={styles.actionsCell}>
                  {record ? (
                    <>
                      <IconButton size="small" aria-label="Editar marco" onClick={() => onRegister(milestone, record)}>
                        <EditOutlinedIcon fontSize="inherit" />
                      </IconButton>
                      <IconButton size="small" aria-label="Excluir marco" onClick={() => onDelete(record)}>
                        <DeleteOutlineIcon fontSize="inherit" />
                      </IconButton>
                    </>
                  ) : (
                    <CustomButton variant="outlined" style="secondary" label="Registrar" onClick={() => onRegister(milestone, null)} />
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MotorMilestonesTable;
